module.exports = "<div class=\"console-log\" ng-if=\"showConsole\">\n    <span>Functionality loaded</span> <br/>\n    <span>Background loading </span><span ng-bind=\"videoProgress\"></span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/console/view.html
// module id = 395
// module chunks = 0